const addOrUpdate = (record, collection) => {
  const isExist = collection.some((item) => item.id === record.id);
  return isExist
    ? collection.map((item) => (item.id === record.id ? record : item))
    : [record, ...collection];
};

export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD_POLICY':
      return {
        ...state,
        policy: action.policy,
      };
    case 'LOAD_PAYMENT_METHODS':
      return {
        ...state,
        paymentMethods: action.paymentMethods,
      };
    case 'ADD_OR_UPDATE_PAYMENT_METHOD':
      return {
        ...state,
        paymentMethods: addOrUpdate(action.paymentMethod, state.paymentMethods),
      };
    case 'DELETE_PAYMENT_METHOD':
      return {
        ...state,
        paymentMethods: state.paymentMethods.filter((item) => item.id !== action.paymentMethodId),
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
